/* global APP_NAME */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
console.log('mount store')

export default new Vuex.Store({
  state: {
    user: null,
    company: {},
    googleKeyAnalytics: null,
    imgPath: 'https://' + APP_NAME + '/img/',
    imgPath2: 'https://' + APP_NAME + '/img',
    productImageURI: 'https://' + APP_NAME + '/productImages',
    //apis
    productV2Api: {
      dev: 'https://o2b4ap6df7.execute-api.us-east-1.amazonaws.com/dev',
      prod: 'https://5oclj22679.execute-api.us-east-1.amazonaws.com/prod'
    },
    opaApi: {
      dev: 'https://3ouhfcxgxb.execute-api.us-east-1.amazonaws.com/dev',
      prod: 'https://7pyahjrqu5.execute-api.us-east-1.amazonaws.com/prod'
    },
    checkoutApi: {
      dev: 'https://xwoj0t6a6c.execute-api.us-east-1.amazonaws.com/dev',
      prod: 'https://qvv5kwf9h6.execute-api.us-east-1.amazonaws.com/prod'
    },
    locationsApi: {
      dev: 'https://p8opcottki.execute-api.us-east-1.amazonaws.com/dev',
      prod: 'https://ug9jvawlu8.execute-api.us-east-1.amazonaws.com/prod'
    },
    deliveryApi: {
      dev: 'https://if9om69l2m.execute-api.us-east-1.amazonaws.com/dev',
      prod: 'https://idbltekm9a.execute-api.us-east-1.amazonaws.com/prod'
    },
    offersApi: {
      dev: 'https://6lwq7683ci.execute-api.us-east-1.amazonaws.com/dev',
      prod: 'https://tcsb9ije74.execute-api.us-east-1.amazonaws.com/prod'
    },
    membershipApi: {
      dev: 'https://fityo7xxxc.execute-api.us-east-1.amazonaws.com/dev',
      prod: 'https://dtx2998n67.execute-api.us-east-1.amazonaws.com/prod'
    },
    chatApi: {
      dev: 'https://8n8z59svx5.execute-api.us-east-1.amazonaws.com/dev',
      prod: 'https://viobaae2t2.execute-api.us-east-1.amazonaws.com/prod'
    },
    productsIndexApi: {
      dev: 'https://cdnproducts.opa4.store/Dev_',
      prod: 'https://cdnproducts.opa4.store/Prod_'
    },
    promotionsApi: {
      dev: 'https://9uust6li9d.execute-api.us-east-1.amazonaws.com/dev',
      prod: 'https://ns774fp118.execute-api.us-east-1.amazonaws.com/prod'
    },
    ratingApi: {
      dev: 'https://58zhbls783.execute-api.us-east-1.amazonaws.com/dev',
      prod: 'https://2n99ocor1e.execute-api.us-east-1.amazonaws.com/prod'
    },

    // membership
    cartPrize: {
      cart_prize_list: [],
      delivery_address_id: 0
    },
    cartPrizeReturnData: null,
    prizes: [],
    tempSpendPoints: 0,
    membershipConfigs: null,
    ///////
    cart: {
      products: [],
      total: 0,
      totalDiscount: 0,
      subTotal: 0,
      deliveryTax: 0,
      cupomDiscount: 0
    },
    cartLocked: false,
    cupomCode: null,
    cupomObject: null,

    //categories
    categories: [],
    lastCategoryId: null,
    lastCategoryProds: [],
    lastCategoryOffset: null,
    lastCategoryOffsetOrder: null,
    //wasteless
    wastelessProducts: [],
    lastWastelessUpdate: 0,
    // products
    products: [],
    lastProductsUpdate: 0,
    // products index
    productsIndex: [],
    productsIndexLoading: false,
    productsIndexLastUpdate: 0,
    // promotinal lists
    productList: [],
    // loadings
    showLoading: false,
    innerLoading: false,
    // login
    tempCode: null,
    tempId: null,
    // checkout
    checkoutViewSelectedAddress: "0",
    checkoutViewSelectedCard: "0",
    checkoutViewCVV: null,
    // search
    searchTerm: null,
    activeSearch: false,
    lastLimitProducts: 20, // the limit need to be controlled if back
    // new search
    searchingProducts: false,
    searchedProducts: [],
    lastSearchTime: 0,
    searchedIndexes: [],
    // bread crumb navigation
    currentScrollY: 0,
    breadCrumb: [],
    breadCrumbSavedPosition: {x: 0, y: 0},
    // ofers
    activateOffers: false,
    offers: [],
    fetchingAllOffers: false,
    // TODO remove
    validationOrigin: null,
    registerLoginOrigin: null,
    registerRequestOrigin: null,
    newAddressOrigin: null,
    newCardOrigin: null,

    // BLOQUEIO
    choicedCompanyId: null,
    choicedCompany: null,
    selectedAddressShort: null,
    lastLatLongUri: null,
    tempAddress: {
      city: null,
      state: null,
      number: null,
      street: null,
      more: null,
      vicinity: null,
      country: null,
      cep: null,
      latLong: null
    },
    loadingView: true,
    selectedAddressId: null,
    addressAlertModal: false

  },
  mutations: {
    setProducts (state, products) {
      state.products = products
    },
    setProductList (state, productList) {
      state.productList = productList
    },
    setCategories (state, categories) {
      state.categories = categories
    },
    setCompany (state, company) {
      state.company = company
    },
    setChoicedCompany (state, choicedCompany) {
      state.choicedCompany = choicedCompany
    },
    setChoicedCompanyId (state, choicedCompanyId) {
      state.choicedCompanyId = choicedCompanyId
    },
    setCvv (state, cvv) {
      state.checkout.cvv = cvv
    },
    setPaymentForm (state, paymentForm) {
      state.checkout.paymentForm = paymentForm
    },
    setDeliveryAdressId (state, deliveryadressId) {
      state.checkout.deliveryadressId = deliveryadressId
    },
    setPaymentformID (state, paymentformID) {
      state.checkout.paymentformID = paymentformID
    },
    setInstallmentNumber (state, installmentNumber) {
      state.checkout.installmentNumber = installmentNumber
    },
    setStage (state, stage) {
      state.checkout.stage = stage
    },
    setWillDelivery (state, willDelivery) {
      state.checkout.willDelivery = willDelivery
    },
    setUser (state, user) {
      state.user = user
    },
    setAddress (state, address) {
      state.address = address
    },
    setOffers (state, offers) {
      state.offers = offers
    },
    setLoadingView(state, loading) {
      state.loadingView = loading
    }
  },
  actions: {

  },
  getters: {
    getLoadingView: (state) => state.loadingView,
    getChoiceCompanyId: (state) => (state.choicedCompanyId ? state.choicedCompanyId : state.company.companyId),
    getChoicedCompany: (state) => (state.choicedCompany ? state.choicedCompany : state.company),
    getCompanyId: (state) => state.company.companyId,
    getCompany: (state) => state.company,
    getProductV2Api: (state) => state.productV2Api[state.company.stage],
    getDeliveryApi: (state) => state.deliveryApi[state.company.stage],
    getOffersApi: (state) => state.offersApi[state.company.stage],
    getChatApi: (state) => state.chatApi[state.company.stage],
    getProductList: (state) => state.productList,
    getOpaApi: (state) => state.opaApi[state.company.stage],
    getCheckoutApi: (state) => state.checkoutApi[state.company.stage],
    getMembershipApi: (state) => state.membershipApi[state.company.stage],
    getPromotionsApi: (state) => state.promotionsApi[state.company.stage],
    getProductsIndexApi: (state) => state.productsIndexApi[state.company.stage],
    getUser: (state) => state.user,
    getProductImageURI: (state) => state.productImageURI,
    getProducts: (state) => state.products,
    getCategories: (state) => state.categories,
    getLogo: (state) => state.company.logo,
    getBanners: (state) => state.company.banners,
    getBannersChild: (state) => state.choicedCompany.banners,
    getColors: (state) => (state.choicedCompany ? state.choicedCompany.colors : state.company.colors),
    getShortName: (state) => state.company.shortName,
    getImgPath: (state) => state.imgPath + (state.choicedCompanyId ? state.choicedCompanyId : state.company.companyId),
    getImgPathBanner: (state) => state.imgPath + (state.choicedCompanyId ? state.choicedCompanyId : state.company.companyId),
    getCart: (state) => state.cart,
    getLocations: (state) => state.locationsApi[state.company.stage],
    getBreadCrumb: (state) => state.breadCrumb,
    getOffers: (state) => state.offers,
    getRatingApi: (state) => state.ratingApi[state.company.stage]
  }
})
